import { Status } from "@chessalpha/core";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
export const StatusSnackbar = ({ status, node, }) => {
    const { t } = useTranslation("StatusSnackbar");
    const stopped = useSnackbar();
    useEffect(() => {
        if (status === Status.STOPPED) {
            const key = stopped.enqueueSnackbar(t("stopped"), {
                persist: true,
            });
            return () => stopped.closeSnackbar(key);
        }
    }, [status, stopped.closeSnackbar, stopped.enqueueSnackbar, t]);
    const started = useSnackbar();
    useEffect(() => {
        if (status === Status.STARTED &&
            node.prev &&
            (node.start || (node.prev.prev && node.prev.start))) {
            const key = started.enqueueSnackbar(t("started"), {
                persist: true,
            });
            return () => started.closeSnackbar(key);
        }
    }, [status, node, started.closeSnackbar, started.enqueueSnackbar, t]);
    const undo = useSnackbar();
    useEffect(() => {
        if (node.undo && !node.next.length) {
            const key = undo.enqueueSnackbar(t(`undo.${node.undo}`), {
                persist: true,
            });
            return () => undo.closeSnackbar(key);
        }
    }, [node, undo.closeSnackbar, undo.enqueueSnackbar, t]);
    return null;
};
//# sourceMappingURL=StatusSnackbar.js.map